import classNames from "classnames";
import styles from "./ContentWrapper.module.scss";

interface Props {
  children: React.ReactNode;
  wide?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const ContentWrapper = ({ children, wide, className, style }: Props) => (
  <div className={classNames(styles.contentWrapper, className, wide ? styles.contentWrapperWide : "")} style={style}>
    {children}
  </div>
);

export default ContentWrapper;
